module.exports = __webpack_public_path__ + "4522113391149e35c299f9fa3812bacb.MP3";